// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2RteF","bigColWidth":"Table_bigColWidth__wAv3g","biggerColWidth":"Table_biggerColWidth__2mEnv","row":"Table_row__3tP4A","col":"Table_col__2p4GS"};